import { ConfigConsumerProps } from '../config-provider/configConsumerProps';
export default {
  name: 'FcEntryMenu',
  props: {
    bgColor: {
      type: String,
      default: '#ffffff',
    },
    width: {
      type: String | Number,
      default: '188px',
    },
    tree: {
      type: Object,
      default: null,
    },
    footerBar: {
      type: Array,
      default: () => {
        return [
          {
            icon: 'check-square',
            name: '操作1',
            click: () => {
              // console.log('点击操作按钮1');
            },
          },
          {
            icon: 'scissor',
            name: '操作2',
            click: () => {
              // console.log('点击操作按钮2');
            },
          },
        ];
      },
    },
  },
  inject: {
    configProvider: { default: () => ConfigConsumerProps }, // 注入依赖，包含组件基本class名方法
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  watch: {},
  methods: {},
  render() {
    const { bgColor, width, footerBar, $slots, tree, $scopedSlots } = this;
    const { getPrefixCls } = this.configProvider;
    const prefixCls = getPrefixCls('', 'fc-function-menu');
    return (
      <div class={prefixCls} style={'background-color:' + bgColor + ';width:' + width}>
        <div class={`${prefixCls}-content`}>
          {tree ? (
            <el-tree
              class="fc-tree"
              {...{ props: tree.props }}
              {...{ on: tree.on }}
              {...{ scopedSlots: $scopedSlots }}
              empty-text=""
              ref="tree"
            ></el-tree>
          ) : null}
          {/* 自定义内容 */}
          {$slots.content}
        </div>
        {/* 底部操作内容 */}
        <div class={`${prefixCls}-operation`}>
          {footerBar &&
            footerBar.slice(0, 2).map((item, index) => {
              return (
                <div onClick={item.click}>
                  <fc-icon class={item.icon}></fc-icon>
                  {item.name}
                </div>
              );
            })}
        </div>
      </div>
    );
  },
};
